import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';

const initialState: { isPreview: boolean } = {
  isPreview: false,
};

const togglePreviewSlice = createSlice({
  name: 'togglePreview',
  initialState,
  reducers: {
    togglePreview(state) {
      state.isPreview = !state.isPreview;
    },
  },
});

export const { togglePreview } = togglePreviewSlice.actions;
export default togglePreviewSlice.reducer;

export const selectPreviewQuestionnaire = (state: RootState) =>
  state.taxQuestionnaire.previewQuestionnaire;
